import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Radio,
  RadioGroup,
  Stack,
} from '@chakra-ui/react';
import { DragEndEvent } from '@dnd-kit/core';
import { FC } from 'react';
import { Crawler } from 'types/crawler';
import { MenuCrawler } from 'types/menuCrawler';
import { useMenuRegistrationStore } from '../../../hooks';
import { CrawlerList } from '../../CrawlerList';
import {
  MenuDescriptionTextarea,
  MenuIdInput,
  MenuNameInput,
} from '../../Forms';

type Props = ReturnType<typeof useMenuRegistrationStore>['form'] & {
  crawlers: Crawler[];
  menuCrawlers: MenuCrawler[];
  handleConfirm: () => void;
  handleAddCrawler: (id: number, parentId: number) => void;
  handleDeleteCrawler: (id: number, parentId: number) => void;
  handleSortCrawler: (event: DragEndEvent) => void;
};

export const MenuRegistrationInputModalView: FC<Props> = ({
  register,
  formState,
  crawlers,
  menuCrawlers,
  handleConfirm,
  handleAddCrawler,
  handleDeleteCrawler,
  handleSortCrawler,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">メニューの登録</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl isRequired isInvalid={!!formState.errors.id}>
          <FormLabel>メニューID</FormLabel>
          <MenuIdInput name="id" register={register} w="240px" />
          <FormErrorMessage>{formState.errors.id?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.name}>
          <FormLabel>メニュー名</FormLabel>
          <MenuNameInput name="name" register={register} />
          <FormErrorMessage>{formState.errors.name?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isRequired>
          <FormLabel>公開範囲</FormLabel>
          <RadioGroup name="type" defaultValue="general">
            <Radio value="general">全顧客</Radio>
          </RadioGroup>
        </FormControl>
        <FormControl isInvalid={!!formState.errors.targetCrawlers}>
          <FormLabel>クローラー</FormLabel>
          <Box
            p="16px"
            borderRadius="md"
            border="solid 1px"
            borderColor="gray.200"
          >
            <CrawlerList
              menuCrawlers={menuCrawlers}
              crawlers={crawlers}
              parentId={-1}
              depth={0}
              update={false}
              handleClickAdd={handleAddCrawler}
              handleDelete={handleDeleteCrawler}
              handleDragEnd={handleSortCrawler}
            />
          </Box>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.description}>
          <FormLabel>説明</FormLabel>
          <MenuDescriptionTextarea
            name="description"
            register={register}
            rows={4}
          />
          <FormErrorMessage>
            {formState.errors.description?.message}
          </FormErrorMessage>
        </FormControl>
      </Stack>
    </ModalBody>
    <ModalFooter justifyContent="center" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        onClick={handleConfirm}
        isDisabled={!formState.isValid}
      >
        確認
      </Button>
    </ModalFooter>
  </ModalContent>
);
